import { render } from "./ui-loading.vue?vue&type=template&id=21105546&ts=true"
import script from "./ui-loading.vue?vue&type=script&lang=ts"
export * from "./ui-loading.vue?vue&type=script&lang=ts"

import "./ui-loading.vue?vue&type=style&index=0&id=21105546&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__